// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";

let Tax = {};

function get(values, field) {
  switch (field) {
    case "Name" :
      return values.name;
    case "Kind" :
      return values.kind;
    case "Color" :
      return values.color;
    case "Tax" :
      return values.tax;
    case "CategoryId" :
      return values.categoryId;
    case "Producer" :
      return values.producer;
    case "Family" :
      return values.family;
    case "Designation" :
      return values.designation;
    case "Country" :
      return values.country;
    case "Region" :
      return values.region;
    case "BeerType" :
      return values.beerType;
    case "WineType" :
      return values.wineType;
    case "WhiteWineType" :
      return values.whiteWineType;
  }
}

function set(values, field, value) {
  switch (field) {
    case "Name" :
      return {
        name: value,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "Kind" :
      return {
        name: values.name,
        kind: value,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "Color" :
      return {
        name: values.name,
        kind: values.kind,
        color: value,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "Tax" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: value,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "CategoryId" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: value,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "Producer" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: value,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "Family" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: value,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "Designation" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: value,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "Country" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: value,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "Region" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: value,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "BeerType" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: value,
        wineType: values.wineType,
        whiteWineType: values.whiteWineType
      };
    case "WineType" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: value,
        whiteWineType: values.whiteWineType
      };
    case "WhiteWineType" :
      return {
        name: values.name,
        kind: values.kind,
        color: values.color,
        tax: values.tax,
        categoryId: values.categoryId,
        producer: values.producer,
        family: values.family,
        designation: values.designation,
        country: values.country,
        region: values.region,
        beerType: values.beerType,
        wineType: values.wineType,
        whiteWineType: value
      };
  }
}

let Lenses_ = {
  get: get,
  set: set
};

let Lenses = {
  get: get,
  set: set
};

let include = Form.Make(Lenses);

let schema = [
  {
    TAG: "StringNotEmpty",
    _0: "Name"
  },
  {
    TAG: "StringNotEmpty",
    _0: "Country"
  },
  {
    TAG: "Custom",
    _0: "Designation",
    _1: param => {
      if (param.designation === "" && param.kind === "WINE") {
        return {
          TAG: "Error",
          _0: I18n.t("Please fulfill this field.")
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "Region",
    _1: param => {
      if (param.region === "" && param.kind === "WINE") {
        return {
          TAG: "Error",
          _0: I18n.t("Please fulfill this field.")
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "Color",
    _1: param => {
      let color = param.color;
      let kind = param.kind;
      if (color !== undefined) {
        let exit = 0;
        if (color === "ROSE" || color === "RED" || color === "ORANGE" || color === "WHITE") {
          if (kind === "WINE") {
            return {
              TAG: "Ok",
              _0: undefined
            };
          }
          exit = 2;
        } else {
          exit = 2;
        }
        if (exit === 2 && (color === "BLOND" || color === "BLACK" || color === "DARK" || color === "AMBER" || color === "RED" || color === "WHITE") && kind === "BEER") {
          return {
            TAG: "Ok",
            _0: undefined
          };
        }
      }
      if (kind === "SPIRITUOUS" || kind === "SIMPLE") {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("Please pick a color.")
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "WineType",
    _1: param => {
      if (param.wineType !== undefined || param.kind !== "WINE") {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("Please pick a wine type.")
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "Family",
    _1: param => {
      if (param.family === "" && param.kind === "SPIRITUOUS") {
        return {
          TAG: "Error",
          _0: I18n.t("Please fulfill this field.")
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "BeerType",
    _1: param => {
      if (param.beerType === "" && param.kind === "BEER") {
        return {
          TAG: "Error",
          _0: I18n.t("Please fulfill this field.")
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    }
  }
];

let Core = include.Core;

let Schema = include.Schema;

let FormLegacyProvider = include.FormLegacyProvider;

let FormProvider = include.FormProvider;

let InputText = include.InputText;

let InputSuggestionComboBox = include.InputSuggestionComboBox;

let InputSelect = include.InputSelect;

let InputToggleButtonGroup = include.InputToggleButtonGroup;

let InputCountrySelect = include.InputCountrySelect;

let InputTextArea = include.InputTextArea;

let InputPassword = include.InputPassword;

let InputNumber = include.InputNumber;

let InputOptionalNumber = include.InputOptionalNumber;

let InputRadioGroup = include.InputRadioGroup;

let InputRadioCardGroup = include.InputRadioCardGroup;

let InputPhone = include.InputPhone;

let InputCheckbox = include.InputCheckbox;

let InputToggleSwitch = include.InputToggleSwitch;

let InputDate = include.InputDate;

let InputOptionalDate = include.InputOptionalDate;

let InputOptionalDateFastNav = include.InputOptionalDateFastNav;

let InputDateRange = include.InputDateRange;

let CancelButton = include.CancelButton;

let SubmitButton = include.SubmitButton;

let ControlEnterKey = include.ControlEnterKey;

let AutoSave = include.AutoSave;

let useFormPropState = include.useFormPropState;

let useField = include.useField;

let useFormState = include.useFormState;

let useFormDispatch = include.useFormDispatch;

let validate = include.validate;

let isValidField = include.isValidField;

export {
  Tax,
  Lenses_,
  Lenses,
  Core,
  Schema,
  FormLegacyProvider,
  FormProvider,
  InputText,
  InputSuggestionComboBox,
  InputSelect,
  InputToggleButtonGroup,
  InputCountrySelect,
  InputTextArea,
  InputPassword,
  InputNumber,
  InputOptionalNumber,
  InputRadioGroup,
  InputRadioCardGroup,
  InputPhone,
  InputCheckbox,
  InputToggleSwitch,
  InputDate,
  InputOptionalDate,
  InputOptionalDateFastNav,
  InputDateRange,
  CancelButton,
  SubmitButton,
  ControlEnterKey,
  AutoSave,
  useFormPropState,
  useField,
  useFormState,
  useFormDispatch,
  validate,
  isValidField,
  schema,
}
/* include Not a pure module */
